import type { FaireProductEntity } from "../../entity_types/product";

export const p_9fc6dy7j74: FaireProductEntity = {
  token: "p_9fc6dy7j74",
  type: "product",
  name: "Large High-Quality Clear Quartz Tower | Master Healer Crystal Point Generator",
  brandToken: "b_9c6sy2bfcu",
  brandName: "Moon Rituals",
  imageUrl:
    "https://cdn.faire.com/fastly/22ff931b42fc8241b9ed0182693c7a30521b692b80058657fb45e67045aa8e52.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ba37a298c7c1dc5af98ce8dfdc874ec2d7f2b074c285cfd8e683a080d09a8a6.jpeg",
    "https://cdn.faire.com/fastly/070ef08069e8f14adc2979651487eb96bf400470b22d1fd5e9317276c7e0fec4.jpeg",
    "https://cdn.faire.com/fastly/27a0f2f98c683b7ec2cec9dbe863b2eccbb3fbad174b84f0decdc37cb6d58b73.jpeg",
    "https://cdn.faire.com/fastly/df3681dd10ba098ca9c62f9aad80c09b63be081782c1542ff64a1ead6d070e23.jpeg",
    "https://cdn.faire.com/fastly/330ca1dcc3cbdd39defa650a47fa27d79473f944e8ffe6f1f40c126d76b6a283.jpeg",
  ],
  priceDollars: 31.2,
  description:
    "\nHarness the Power of Clear Quartz with Our Stunning Tower\n\nDiscover the unparalleled clarity and amplification of our high-quality Clear Quartz Tower. This natural crystal masterpiece is meticulously crafted to enhance your spiritual journey and personal growth.\n\nPlace it in your meditation space, home office, or any area where you desire increased focus, clarity, and positive energy.\n\nBenefits of Clear Quartz:\n\n * Amplifies energy and thoughts \n * Enhances clarity, focus, and concentration \n * Promotes spiritual growth and awareness \n * Cleanses and purifies the aura \nCare Instructions:\n\n * Cleanse regularly with water or smudging \n * Recharge in sunlight or moonlight \nExperience the transformative power of Clear Quartz. Add this magnificent tower to your crystal collection and unlock your full potential.\n",
  tags: [],
  msrpDollars: 78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:58.634Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
